import React from "react";

function Nav() {
  return (
    <div className="nav">
      <h2>digital</h2>
      <ul>
        <li>Services</li>
        <li>About</li>
        <li>Project</li>
        <li>Contact</li>
      </ul>
    </div>
  );
}

export default Nav;
